export default "__VITE_ASSET__xbGrHYhu__"